import React, { Component } from "react";
import "../../Page/Dashboard/index.css";
import { MDBRow, MDBCol } from "mdbreact";
import { NavLink, withRouter } from "react-router-dom";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";
import { BiGridSmall } from "react-icons/bi";
import mixpanel from "mixpanel-browser";

import "./index.css";

import { HiLightningBolt, HiSortAscending } from "react-icons/hi";
import { GoPrimitiveDot } from "react-icons/go";

import { TiTick } from "react-icons/ti";
import { firebase } from "../../../firebase/config";
import MobileFooter from "../Layout/mobileFooter";

import MobileTopMenu from "../Layout/mobileTopMenu";

class DemoMobile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      querySellers: [],
      Email: "",
      Password: "",
      error: "",
      price: "",
    };

    this.onChange = this.onChange.bind(this);
    this.onSubmitEmail = this.onSubmitEmail.bind(this);
  }

  onChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  };

  onSubmitEmail = (event) => {
    if (!this.state.Email || !this.state.Password) {
      return this.setState({ error: "Missing email or password" });
    } else {
      firebase
        .auth()
        .signInWithEmailAndPassword(
          this.state.Email.trim(),
          this.state.Password.trim()
        )
        .then(() => {
          this.setState({ error: null });
          window.location = "";
        })
        .catch((error) => {
          this.setState({ error: error.message });
        });
    }

    event.preventDefault();
  };

  componentDidMount() {
    const params = new URLSearchParams(window.location.search);
    this.setState({
      price: params.get("price"),
    });
  }

  render() {
    return (
      <>
        <MDBCol
          style={{
            width: "105vw",
            overflowX: "hidden",
            paddingBottom: 0,
            height: "100vh",
          }}
          size="12"
        >
          <MDBRow style={{ marginTop: 70 }}>
            <MDBCol size="12">
              <NavLink to="/" exact onClick={() => window.scrollTo(0, 0)}>
                <p
                  style={{
                    fontFamily: "Grifter",
                    color: "black",
                    fontSize: 23,
                    fontWeight: "900",
                    marginTop: -45,
                    marginLeft: 15,
                  }}
                >
                  {" "}
                  YouDub<sup>TM</sup>
                </p>
              </NavLink>
            </MDBCol>

            <div className="d-flex justify-content-center">
              <MDBRow style={{ marginTop: -10 }}>
                <MDBCol className="d-flex justify-content-center " size="12">
                  <div
                    style={{
                      height: 430,
                      zIndex: 6,
                      marginTop: 0,
                      width: "90vw",
                    }}
                  >
                    <MDBRow>
                      <MDBCol size="12">
                        <p
                          style={{
                            fontFamily: "PlusJSBold",
                            fontSize: 23,
                            fontWeight: "800",
                            marginTop: 50,
                            marginLeft: 34,
                            lineHeight: 1.2,
                          }}
                        >
                          Log In
                        </p>
                      </MDBCol>

                      <MDBCol
                        className="d-flex justify-content-center"
                        size="12"
                      >
                        <div
                          style={{
                            width: "380px",
                            marginTop: 8,
                            marginLeft: 34,
                          }}
                          className="form-group"
                        >
                          <input
                            type="text"
                            className="form-control"
                            id="formGroupExampleInput"
                            name="Email"
                            placeholder="Email address"
                            value={this.state.Email}
                            onChange={this.onChange}
                            style={{
                              height: "44px",
                              border: "1.4px solid #d8d9dc",
                              fontFamily: "PlusJSMedium",
                              fontSize: 14,
                              paddingTop: 24,
                              paddingBottom: 24,
                              borderRadius: 0,
                              color: "black",
                              opacity: 1,
                            }}
                            autoComplete="off"
                          />
                        </div>
                      </MDBCol>
                      <MDBCol
                        className="d-flex justify-content-center"
                        size="12"
                      >
                        <div
                          style={{ width: "380px", marginLeft: 34 }}
                          className="form-group"
                        >
                          <input
                            type="password"
                            className="form-control"
                            id="formGroupExampleInput"
                            name="Password"
                            placeholder="Password"
                            value={this.state.Password}
                            onChange={this.onChange}
                            style={{
                              height: "44px",
                              border: "1.4px solid #d8d9dc",
                              paddingTop: 24,
                              paddingBottom: 24,
                              borderRadius: 0,
                            }}
                            autoComplete="off"
                          />
                        </div>
                      </MDBCol>

                      <MDBCol
                        className="d-flex justify-content-center "
                        size="12"
                      >
                        <div
                          onClick={(e) => this.onSubmitEmail(e)}
                          className="buttonSpecial9"
                          style={{
                            cursor: "pointer",
                            fontSize: 16,
                            width: 380,
                            height: 60,
                            marginLeft: 34,
                            marginTop: 0,
                          }}
                        >
                          Log In
                        </div>
                      </MDBCol>
                      <MDBCol
                        className="d-flex justify-content-center "
                        size="12"
                      >
                        {this.state.error ? (
                          <p
                            className="d-inline"
                            style={{
                              fontFamily: "PlusJSRegular",
                              fontSize: 11,
                              marginTop: 12,
                              position: "absolute",
                              color: "red",
                            }}
                          >
                            {this.state.error}
                          </p>
                        ) : null}
                      </MDBCol>
                      <MDBCol
                        className="d-flex justify-content-center "
                        size="12"
                      >
                        <p
                          className="d-inline"
                          style={{
                            fontFamily: "PlusJSRegular",
                            fontSize: 11,
                            marginTop: 40,
                            marginLeft: 34,
                          }}
                        >
                          Having trouble logging in?{" "}
                          <a
                            href="mailto:help@youdub.me"
                            className="d-inline"
                            style={{ color: "#FF0000", fontWeight: 700 }}
                          >
                            {" "}
                            Get in touch
                          </a>
                        </p>
                      </MDBCol>
                      <MDBCol
                        className="d-flex justify-content-center  "
                        size="12"
                      >
                        <div
                          className=" d-flex justify-content-center  "
                          style={{
                            fontFamily: "PlusJSRegular",
                            backgroundColor: "black",
                            width: 380,
                            marginLeft: 34,
                            marginTop: 30,
                            height: 50,
                          }}
                        >
                          <p
                            className="d-inline"
                            style={{
                              fontFamily: "PlusJSRegular",
                              fontSize: 13,
                              marginTop: 14,
                              color: "white",
                            }}
                          >
                            Don't have an account?{" "}
                            <p
                              className="d-inline"
                              style={{ color: "#EA552B", fontWeight: 700 }}
                            >
                              {" "}
                              <a
                                href=""
                                style={{
                                  color: "white",
                                  fontWeight: 700,
                                  marginLeft: 5,
                                }}
                                exact
                                onClick={() => window.scrollTo(0, 0)}
                              >
                                Book a meeting
                              </a>
                            </p>
                          </p>
                        </div>
                      </MDBCol>

                      <MDBCol
                        className="d-flex justify-content-center "
                        size="12"
                      >
                        <p
                          className="d-inline"
                          style={{
                            fontFamily: "PlusJSRegular",
                            fontSize: 11,
                            marginTop: 20,
                            marginLeft: 34,
                          }}
                        >
                          © Copyright 2023 YouDub, LLC
                        </p>
                      </MDBCol>
                    </MDBRow>
                  </div>
                </MDBCol>
              </MDBRow>
            </div>
          </MDBRow>
        </MDBCol>
      </>
    );
  }
}

export default withRouter(DemoMobile);
